<template>
  <InputOptionalValidation
    v-model="OptionalValidationModel"
    v-validate="config.validate || ''"
    v-bind="config"
    :inputClass="config.inputClass"
    :tooltip="tooltip"
    :type="config.type || 'text'"
    @blur="handleBlur"
    @change="handleChange"
    @enter="handleEnter"
    @focus="handleFocus"
    @input="handleInput"
  />
</template>

<script>
import InputOptionalValidation from 'client/components/FormValidation/Input.vue';
import TooltipPropMixin from 'components/FormValidation/mixins/TooltipPropMixin';
import ValidatorMixin from 'client/components/FormValidation/mixins/ValidatorMixin';

export default {
  name: 'InputValidator',

  components: { InputOptionalValidation },

  mixins: [
    ValidatorMixin,
    TooltipPropMixin,
  ],
};

/**
 *  How to Use the InputOptionalValidation Component
 *
 *  Import it into the component you want to use it in:
 *  import InputValidator from 'client/components/FormValidation/InputValidator.vue'
 *
 *  register it:
 *  components: { InputValidator },
 *
 *  then in your template,
 *
 *  Pass nothing, and get an Input that has no validation:
 *  <InputValidator/>
 *
 *  Or pass an object prop named config:
 *  <InputValidator
 *    :config="{
 *      label:'the label',
 *      name: 'the real email',
 *      autocomplete: 'on',
 *      placeholder: 'I require a valid email address',
 *      validate: 'required|email', <-- that's v_validate syntax
 *    }"
 *  />
 *  <InputValidator
 *    :config="{
 *      label:'the second one',
 *      name: 'fake email',
 *      placeholder: 'give me anything',
 *      validate: 'required',
 *    }"
 *  />
 *  <InputValidator
 *    :config="{
 *      label:'5 characters. That\'s it',
 *      validate: 'min:5', <-- that's v_validate syntax
 *    }"
 *  />
 *
 *  You can also pass it as a data method:
 *  <InputValidator :config="AllMyOptions" />
 *  data: () => ({
 *    AllMyOptions: {
 *      value: null,
 *      label: null,
 *      required: null,
 *      disabled: null,
 *      validate: null,
 *      type: null,
 *      name: null,
 *      autocomplete: null,
 *      placeholder: null,
 *    }
 *  })
 *
 * re: inject: ['$validator'],
 * Vee-Validate is a mixin. After Vue.use(VeeValidate) a v-validate instance
 * is on every Vue component in the application. When a v-validate directive
 * is added as an attribute those rules, validation states, and errors can
 * then be shared with *any* component along the component tree, as long as
 * they all have the $validator injected. Always try to share Errors and
 * v-validate state among components instead of using DOM queries.
 */
</script>
